import React from 'react';
import { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import ImageModal from "../Outerinnerpage/KYC/ImageModal";

const Profile = () => {

  const [profiledata, setProfile] = useState([]);
  const baseurl="https://apimlm.bloomitsolutions.in"
  

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    });
  

  useEffect(() => {
    const getProfile = async () => {
      try {
        const response = await axios.get("https://apimlm.bloomitsolutions.in/vendorroutes/getAllVendorDetails");
        const empData = response.data;
        setProfile(empData);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
    getProfile();
  }, []);

  const [showImageModal, setShowImageModal] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState("");


  const openImageModal = (imageUrl) => {
    setEnlargedImageUrl(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setEnlargedImageUrl("");
    setShowImageModal(false);
  };


  return (
    <div>
    <Container>        
      <div className='container'>
          <div className='row '>
              <div className='col-lg-12 ' ref={componentRef}>
                  <div className='row ' style={{display:"flex"}} >
                  </div>
                  <div className="row ">
                      <div className="col-lg-6 mt-4  ">
                          
                      </div>
                  </div>
           
                  <div className="row mt-4">
                  <div className="col-lg-12">
                      <div className="card">
                      <div className="card-header"  style={{backgroundColor: "rgb(0, 156, 0)",color:'white'}}>
                          <h4> Vendor Profile </h4>
                      </div>
                      <div className="card-body">
                          {/* <div className=""> */}
                          <div className="mb-2">
                          {/* <Button className='rounded-0'>Copy</Button>
                          <Button className='rounded-0'>Excel</Button> */}
                          <Button className='rounded-0'  onClick={handlePrint} >Download PDF</Button>
                          {/* <Button className='rounded-0'>Column visibility</Button> */}
                        </div>
                          {/* </div> */}
                          <form>
                          <div className="card-body">
                              <div className='table-responsive' >
                              <table className="table table-bordered">
        
                              <thead>
                                  <tr>
                                  <th scope="col">Id</th>
                                  <th scope="col">Vendor Id</th>
                                  <th scope="col">Address</th>
                                  <th scope="col">D.O.B</th>
                                  <th scope="col">Nominee Name</th>
                                  <th scope="col">Gender </th>
                                  <th scope='col'>Profile Pic</th>
                                  {/* <th scope="col">Profile picture</th> */}
                                  {/* <th scope="col">Admin Services Charges</th>
                                  <th scope="col">Status</th> */}
                                  
                                 
                                  </tr>
                              </thead>
                              <tbody>
                            {profiledata.map((product, index) => (
                              <tr key={index}>
                                <td>{product.id}</td>
                                <td>{product.vendorId}</td>
                                <td>{product.address}</td>
                                <td>{product.dob}</td>
                                <td>{product.nominee_name}</td>
                                <td>{product.gender}</td>
                               
                                <td>
                                <img
                                  src={`${baseurl}/${product.profile_pic}`}
                                  className="img-fluid"style={{ width: "100px",
                                  height: "100px",
                                  maxWidth: "100px",
                                  maxHeight: "100px",}}
                                  onClick={() => openImageModal(`${baseurl}/${product.profile_pic}`)}
                                />
                              </td>
                                {/* <td>{product.profile_pic}</td> */}
                                {/* <td><img src={`${baseurl}/${product.profile_pic}`} className="img-fluid"style={{ maxWidth: "100px", maxHeight: "100px" }}/></td> */}

                                {/* <td>
                                  <img
                                    src={product.image}
                                    alt={product.title}
                                    width="50"
                                  />
                                </td> */}
                                 
                                {/* <td>
                                 
                                 <Link to="/Update"> <button className='btn btn-primary'>Update</button></Link>
                                </td> */}
                               
                              </tr>
                            ))
                            }
                            </tbody>


                              </table>
                              <nav aria-label="...">
                                  <ul class="pagination">
                                    <li class="page-item disabled">
                                      <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                                    </li>
                                    <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                    <li class="page-item" aria-current="page">
                                      <a class="page-link" href="#">2</a>
                                    </li>
                                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                                    <li class="page-item">
                                      <a class="page-link" href="#">Next</a>
                                    </li>
                                  </ul>
                                  </nav>
                              </div>
                              
                          </div>
                          {/* /.card-body */}
                          </form>
                      </div>
                      </div>
                  </div>
                  </div>

              </div>

          </div>

      
      </div>
      
    
    
  </Container>

  {showImageModal && (
        <ImageModal
          isOpen={showImageModal}
          onRequestClose={closeImageModal}
          imageUrl={enlargedImageUrl}
        />
      )}

    </div>
  )
}

export default Profile;